import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { utilButton } from "../../utils/utilButton";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { GridItemContainerDefault } from "../generic/common/GridItemContainerDefault";
import { IconWithModifier } from "../generic/icon-with-modifier/IconWithModifier";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLocaValueProportional } from "../generic/text/TextLocaValueProportional";
export var GridItemMarketImprovement = React.memo(function (_a) {
    var item = _a.item, onClick = _a.onClick, className = _a.className;
    var balancing = item.balancing, icon = item.icon, level = item.level;
    var totalLevels = balancing.level.length;
    var modifierIconProps = {
        icon: IdIcon.PlusResearchIcn,
        position: IdBadgePosition.BottomLeft,
        styleId: IdStyles.IconSmall,
    };
    return (React.createElement(GridItemContainerDefault, { className: "" + className, onClick: function () { return utilButton.onClickWithSound(onClick); } },
        React.createElement("div", { className: "market-improvement__item" },
            React.createElement("div", null,
                React.createElement(IconWithModifier, { styleId: IdStyles.IconExtraLarge, icon: icon, modifierIconProps: modifierIconProps })),
            React.createElement(TextLocaValueProportional, { className: IdStyles.TextNormal, available: level, required: totalLevels }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/market/GridItemMarketImprovement.tsx
// module id = 2710
// module chunks = 3